import type {AuthAgent} from 'quickstart/types'
import {logger} from 'tizra'
import {useGlobalBlockConfig} from './useGlobalBlockConfig'

const log = logger('useAuthConfig')

interface UseAuthConfigProps {
  authAgent?: AuthAgent | ''
}

const authAgentSupportsRegistrationAndReset = (authAgent: AuthAgent) =>
  authAgent === 'internal'
    ? true
    : authAgent === 'custom' &&
        typeof window !== 'undefined' &&
        window.tizra?.customLoginUrl
      ? false
      : authAgent === 'custom'

export const useAuthConfig = (props: UseAuthConfigProps = {}) => {
  const {logoLink, logoUrl} = useGlobalBlockConfig('theme')
  const authConfig = {
    ...useGlobalBlockConfig('signin'),
    logoLink,
    logoUrl,
  }
  log.debug?.('global authConfig is:', authConfig)
  if (props.authAgent) {
    log.debug?.('received authAgent in props:', props.authAgent)
    authConfig.authAgent = props.authAgent
  } else if (props.authAgent === '' && authConfig.authAgent === 'custom') {
    // If props.authAgent is empty string, that means to inherit the global
    // default. However if the global default is "custom", then honor the
    // historical interpretation which is to provide the Tizra auth back door.
    log.debug?.('empty authAgent in props, overriding custom to internal')
    authConfig.authAgent = 'internal'
  }
  if (!authAgentSupportsRegistrationAndReset(authConfig.authAgent)) {
    log.debug?.(
      `authAgent is ${authConfig.authAgent}, disabling passwordReset and registration`,
    )
    authConfig.passwordReset.enabled = false
    authConfig.registration.enabled = false
  }
  log.debug?.('authConfig is', authConfig)
  return authConfig
}
